import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "../../lib/api";
import SEO from "../../components/SEO";
import { inputCls } from "../admin/AFields";

export default function StudioAudit() {
  const [items, setItems] = useState([]);
  const [shares, setShares] = useState([]);
  const [q, setQ] = useState("");

  const load = () => {
    api.get(`/studio/audit?q=${encodeURIComponent(q)}`).then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e)));
    api.get("/greetings/shares").then((r) => setShares(r.data)).catch((e) => toast.error(errMsg(e)));
  };
  useEffect(() => { load(); }, []); // eslint-disable-line

  return (
    <div data-testid="studio-audit">
      <SEO title="History & Audit" />
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <h1 className="font-display text-2xl font-bold tracking-tight text-navy sm:text-3xl">History & Audit</h1>
          <p className="mt-1 text-sm text-slate-500">Greeting actions, share history, campaigns, automation, integrations and imports.</p>
        </div>
        <div className="flex gap-2">
          <input value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} placeholder="Search actor / action…" className={`${inputCls} !w-64`} data-testid="audit-search" />
          <button onClick={load} className="rounded-md border border-gray-200 bg-white px-4 py-2 text-xs font-bold text-navy" data-testid="audit-search-btn">Search</button>
        </div>
      </div>

      <div className="mt-6 overflow-x-auto rounded-lg border border-gray-200 bg-white">
        <table className="w-full min-w-[680px] text-sm">
          <thead>
            <tr className="border-b border-gray-100 text-left text-xs font-bold uppercase tracking-wider text-slate-500">
              <th className="px-4 py-3">Time</th><th className="px-4 py-3">Administrator</th><th className="px-4 py-3">Action</th><th className="px-4 py-3">Module</th><th className="px-4 py-3">Detail</th>
            </tr>
          </thead>
          <tbody>
            {items.map((l) => (
              <tr key={l.id} className="border-b border-gray-50" data-testid={`audit-row-${l.id}`}>
                <td className="whitespace-nowrap px-4 py-3 text-xs text-slate-500">{String(l.at || "").replace("T", " ").slice(0, 19)}</td>
                <td className="px-4 py-3 text-xs font-semibold">{l.actor}</td>
                <td className="px-4 py-3"><span className="rounded-full bg-navy-50 px-2.5 py-0.5 text-xs font-bold text-navy">{l.action}</span></td>
                <td className="px-4 py-3 text-xs">{l.entity}</td>
                <td className="max-w-[280px] truncate px-4 py-3 text-xs text-slate-500" title={l.detail}>{l.detail}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={5} className="px-4 py-12 text-center text-sm text-slate-400">No audit entries yet.</td></tr>}
          </tbody>
        </table>
      </div>

      <div className="mt-8 rounded-lg border border-gray-200 bg-white p-5" data-testid="share-history">
        <h2 className="font-display text-lg font-bold text-navy">Greeting Share History</h2>
        <div className="mt-4 overflow-x-auto">
          <table className="w-full min-w-[560px] text-sm">
            <thead>
              <tr className="border-b border-gray-100 text-left text-xs font-bold uppercase tracking-wider text-slate-500">
                <th className="px-3 py-2">Time</th><th className="px-3 py-2">Greeting</th><th className="px-3 py-2">Contact</th><th className="px-3 py-2">Action</th>
              </tr>
            </thead>
            <tbody>
              {shares.map((s) => (
                <tr key={s.id} className="border-b border-gray-50" data-testid={`share-row-${s.id}`}>
                  <td className="whitespace-nowrap px-3 py-2 text-xs text-slate-500">{String(s.at || s.created_at || "").replace("T", " ").slice(0, 19)}</td>
                  <td className="px-3 py-2 text-xs font-semibold text-navy">{s.greeting_title || s.greeting_id}</td>
                  <td className="px-3 py-2 text-xs">{s.contact_name || s.contact_id || "—"}</td>
                  <td className="px-3 py-2"><span className="rounded-full bg-saffron-100 px-2.5 py-0.5 text-xs font-bold text-saffron-600">{s.action}</span></td>
                </tr>
              ))}
              {shares.length === 0 && <tr><td colSpan={4} className="px-3 py-8 text-center text-sm text-slate-400">No share history yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
